<!-- @format -->

<member-edit-modal>
  <div
    class="modal js-modal"
    is="modal-base"
    is-open="{ props.isOpen }"
    on-before-show="{ onBeforeShow }"
  >
    <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
    <div class="modal__content">
      <div class="modal__content_inner" if="{ props.member.user_info }">
        <h2 class="heading-01 heading_edit">メンバー設定の編集</h2>

        <div class="container_user-account">
          <div class="user-account_name">
            <div class="user-account_name-icon">
              <img
                if="{ props.member.user_info.icon_path }"
                src="{ props.member.user_info.icon_path }"
                alt=""
              />
              <img
                if="{ !props.member.user_info.icon_path }"
                src="/assets/img/icon_default.svg"
                alt=""
              />
            </div>
            <p class="user">{ props.member.name }</p>
            <p class="user-account_role">
              { Role.get(props.member.role).name} /
              {props.member.user_info.group_name || ""}
            </p>
          </div>
        </div>
        <!--/.container_user-account-->

        <form class="" name="form01" action="">
          <div class="container_input">
            <div class="wrap_input wrap_input-30">
              <label class="form-heading" for="role">権限</label>
              <select
                name="role"
                id="role"
                class="sort-list"
                onchange="{ onRole }"
              >
                <option each="{ role in Role.roles() }" value="{ role.id }">
                  { role.name }
                </option>
              </select>
            </div>
            <!--/.wrap_input-->
            <div class="wrap_input wrap_input-60">
              <label class="form-heading" for="group">
                部署名/所属グループ名
              </label>
              <input
                class="text_input"
                type="text"
                name="group_name"
                is="binding"
                data="{ state }"
                oninput="{ onGroupName }"
                id="orgroupders_number"
                placeholder=""
              />
            </div>
            <!--/.wrap_input-->
          </div>
          <!--/.container_input-->

          <div class="box_input">
            <h3 class="form-heading">利用可能サービス</h3>
            <div class="inner_input" each="{ service in services }">
              <div class="checkbox_wrap02">
                <input
                  type="checkbox"
                  name="{ service.id }"
                  id="input-{ service.id }"
                  class="checkbox-input js-check-02"
                  onclick="{ onCheck }"
                />
                <label for="input-{ service.id }" class="checkbox-parts">
                  { service.name }
                </label>
              </div>
              <p class="role">権限：</p>
              <div class="sort-menu">
                <select
                  name="{ service.id }"
                  class="sort-list select_checked"
                  onchange="{ onServiceRole }"
                >
                  <option each="{ role in Role.roles() }" value="{ role.id }">
                    { role.name }
                  </option>
                </select>
              </div>
            </div>
            <!--/.inner_input-->
          </div>
          <!--/.container_input-->
        </form>

        <p class="notice">
          ※「CROCOデスクオンライン」の各種サービスについては、利用制限をかける事ができませんのでご了承ください。
        </p>

        <div class="container_button">
          <button
            class="button button-clear js-modal-close"
            type="button"
            onclick="{ props.onClose }"
          >
            キャンセル
          </button>
          <button
            class="button button-primary button-primary-mini"
            type="button"
            onclick="{ change }"
          >
            設定の更新
          </button>
        </div>
        <!--/.container_button-->
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div>
    <!--modal__content-->
  </div>
  <!--modal-->

  <script>
    import di from "dependency-injection";
    import Role from "@model/role.js";
    import base from "../modal-base.riot";

    export default {
      components: {
        "modal-base": base,
      },
      services: [
        { id: "croco-desk", name: "CROCOデスク" },
        { id: "croco-desk-online", name: "CROCOデスクオンライン" },
        { id: "edilent-client", name: "EDILENT for Client" },
        { id: "adapt-write", name: "yori-co" },
      ],
      state: { checks: {} },
      onBeforeShow() {
        const nextState = {
          role: this.props.member.role,
          group_name: String(this.props.member?.user_info?.group_name ?? ""),
          service_role: this.services.reduce((a, c) => {
            a[c.id] = this.props.member.services[c.id]
              ? this.props.member.services[c.id].role_id
              : "master";
            return a;
          }, {}),
          checks: this.services.reduce((a, c) => {
            a[c.id] = !!this.props.member.services[c.id];
            return a;
          }, {}),
        };
        this.update(nextState);

        this.$(`select[name="role"]`).value = this.state.role;
        this.$(`input[name="group_name"]`).value = this.state.group_name;
        for (const service of this.services) {
          this.$(`input[name="${service.id}"]`).checked = this.state.checks[
            service.id
          ];
          let select = this.$(`select[name="${service.id}"]`);
          select.value = this.state.service_role[service.id];
          select.disabled = !this.state.checks[service.id];
        }
        this.update();
      },
      onRole(e) {
        this.update({ role: e.target.value });
      },
      onGroupName(e) {
        this.update({ group_name: e.target.value });
      },
      onCheck(e) {
        this.state.checks[e.target.name] = e.target.checked;
        this.$(`select[name="${e.target.name}"]`).disabled = !e.target.checked;
        this.update({ checks: this.state.checks });
      },
      onServiceRole(e) {
        this.state.service_role[e.target.name] = e.target.value;
        this.update({ services: this.state.service_role });
      },
      change(e) {
        const param = {
          bizid: this.props.member.id,
          role: this.state.role,
          group_name: this.state.group_name,
          service_role: this.services.reduce((a, c) => {
            a[c.id] = this.state.checks[c.id]
              ? this.state.service_role[c.id]
              : "";
            return a;
          }, {}),
        };
        this.props.onUpdateMember(param);
      },
      onBeforeMount(props, state) {
        this.Role = Role;
      },
    };
  </script>
</member-edit-modal>
